import {
  API_AUTH_ERRORS,
  API_ERRORS,
  EBasicErrorCode,
  JSTP_ERRORS,
  LDAP_ERRORS,
} from '@infotech-soe/merps/types/errors';
import { tg } from '@infotech-soe/metaschema';

import { ErrorNotificationKey } from '../../../types';
import error from '../../slices/error';
import { createAppListener } from '../listenerHelpers';

const errorListener = createAppListener();

const messages: Partial<Record<EBasicErrorCode, ErrorNotificationKey>> = {
  [API_ERRORS.ACTION_CANCELLED]: 'actionCancelled',
  [JSTP_ERRORS.ERR_AUTH_FAILED]: 'authFailed',
  [JSTP_ERRORS.ERR_INTERNAL_API_ERROR]: 'internalApiError',
  [JSTP_ERRORS.ERR_CONNECTION_LOST]: 'connectionLost',
  [API_AUTH_ERRORS.NOT_AUTHENTICATED]: 'notAuthenticated',
  [API_AUTH_ERRORS.CHANGE_PASSWORD]: 'needChangePass',
  [API_AUTH_ERRORS.WRONG_PASSWORD]: 'wrongUsernameOrPassword',
  [API_AUTH_ERRORS.ACCOUNT_BLOCKED]: 'accountBlocked',
  [API_AUTH_ERRORS.APP_NOT_AVAIL]: 'appNonAvailable',
  [API_AUTH_ERRORS.ACTION_NOT_PERMITTED]: 'actionNotPermitted',
  [API_AUTH_ERRORS.CATEGORY_NOT_PERMITTED]: 'categoryNotPermitted',
  [API_AUTH_ERRORS.REQUIRED_SMART_CARD]: 'smartCardAuthRequired',
  [API_AUTH_ERRORS.MAX_SESSIONS_EXCEEDED]: 'maxSessionExceeded',
  [API_AUTH_ERRORS.SAME_PASSWORD]: 'samePasswords',
  [API_AUTH_ERRORS.WEAK_PASSWORD]: 'weakPassword',
  [LDAP_ERRORS.PASSWORD_EXPIRED]: 'passwordExpired',
  [LDAP_ERRORS.ACCOUNT_DISABLED]: 'accountDisabled',
  [LDAP_ERRORS.ACCOUNT_LOCKED]: 'accountLocked',
  [LDAP_ERRORS.ACCOUNT_EXPIRED]: 'accountExpired',
  [LDAP_ERRORS.LOGON_TIME_RESTRICTION]: 'logonTimeRestriction',
  [LDAP_ERRORS.WORKSTATION_RESTRICTION]: 'workstationRestriction',
};

const logoutCodes: Set<number> = new Set([1301, 1302]);

const getMessage = (code: EBasicErrorCode): ErrorNotificationKey => {
  return messages[code] || 'systemError';
};

errorListener.startListening({
  predicate: (action: any) => action.error === true,
  effect: ({ payload }, api) => {
    let name = 'unknown';
    let id: string | null = null;
    let code: number | null = null;
    let message = '';
    let stack: string | null = null;
    let info: string | null = null;
    let logout = false;

    if (payload instanceof Error) {
      info = (() => {
        if (tg.hasProperty(payload, 'info')) {
          if (Array.isArray(payload.info)) {
            return payload.info[0] || null;
          } else {
            return payload.info || null;
          }
        }
        return null;
      })();
      name = payload.name;
      message = payload.message;
      stack = payload.stack || null;

      const errorCode: number | undefined = (payload as any).code;

      if (errorCode) {
        code = errorCode;
        logout = logoutCodes.has(code);
        id = getMessage(errorCode);
      }
    } else if (payload instanceof Event) {
      name = 'DOM Error Event';

      if (payload.target) {
        message = payload.target.constructor.name;
      }
    } else {
      message = (payload as any)?.toString() || 'Unknown error';
    }

    api.dispatch(
      error.showNotification({
        name,
        id,
        code,
        message,
        stack,
        info,
        logout,
      })
    );
  },
});

export default errorListener.middleware;
